import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { getCookie } from '@auth/bp-pf-auth';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  router = inject(Router)

  navigateToURLWithtenantCode(path: string, newTab: boolean = false): void {
    const tenantCode = getCookie(`${environment.app_id}_tenant_code`);
    const url = `/${tenantCode}/${path}`;

    if (newTab) {
      window.open(url, '_blank');
    } else {
      this.router.navigate([url]);
    }
  }
}
